export const FILTER_THROTTLE_TIMEOUT = 500;
export const FILTER_PAGE_SIZE = 10;
